import React, {useState, useEffect, useRef} from 'react';

import './ColumnsThree.css';

import User from './User.mjs';
import ColumnUser from './ColumnUser.mjs';
import ColumnTeam from './ColumnTeam.mjs';
import ColumnActionItem from './ColumnActionItem.mjs';
import ColumnAppAdmin from './ColumnAppAdmin.mjs';
import {useScreenWidth} from './WindowSizeHook.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ColumnsTree() 
{
    const {num_display_columns, setNumDisplayColumns, main_column_display_type, setTeamID, setTeam, setTeamMemberRole, 
           setActionItem, setShortTermGoal, setTeamMembersList} = useCTAL();
 
    const [left_column_display,  setLeftColumnDisplay] = useState(<ColumnUser />);
    const [main_column_display,  setMainColumnDisplay] = useState(<ColumnTeam />);
    const [right_column_display, setRightColumnDisplay] = useState(<ColumnActionItem />);
    const columnRef = useRef(4);

    const widthSize = useScreenWidth()
    const oneColumnMaxWidth = 767;
    const twoColumnMaxWidth = 1200;
    var numColumns = 1;
    
    if      (widthSize <= oneColumnMaxWidth) numColumns = 1;
    else if (widthSize <  twoColumnMaxWidth) numColumns = 2;
    else                                     numColumns = 3;

    //Have to be careful about calling setNumDisplayColumns or else we go into an endless refresh loop ... and nobody likes that.
    if (columnRef.id != numColumns)
    {
        columnRef.id = numColumns;
        if (num_display_columns != numColumns)
        {
            setNumDisplayColumns(numColumns);
            if (DEBUG) console.log(`ColumnsTree** - ${numColumns} Columns, widthSize: ${widthSize}`)
        }
    }

    useEffect(() =>
    {
        switch (num_display_columns)
        {
            case 3:
            default:
                setLeftColumnDisplay( <ColumnUser />);
                setMainColumnDisplay( <ColumnTeam />);
                setRightColumnDisplay(<ColumnActionItem />);
                break;
            case 2:
                setLeftColumnDisplay( <> </>);
                setMainColumnDisplay( <ColumnTeam />);
                setRightColumnDisplay(<ColumnActionItem />);
                break;
            case 1:
                setLeftColumnDisplay( <> </>);
                setMainColumnDisplay( <ColumnTeam />);
                setRightColumnDisplay(<> </>);
                break;
        }
    }, [num_display_columns]);

    useEffect(() =>
    {
        if (DEBUG) console.log(`ColumnsTree*** setMainColumnDisplay: ${main_column_display_type}`);
        
        switch (main_column_display_type)
        {
            case "Team":
            default:
                setMainColumnDisplay( <ColumnTeam />);
                break;
            case "User":
                setTeamID("");  //If we're traversing back to User, need to Clear Team and Action Item
                setTeam(undefined); 
                setTeamMemberRole("");
                setTeamMembersList([]); //need to clear Team Member List so that Assign User does not display in ActionItemForm for Short/Long List
                setActionItem(undefined);
                setShortTermGoal(undefined);   
                setMainColumnDisplay( <ColumnUser />);
                break;
            case "Action-Item":
                setMainColumnDisplay( <ColumnActionItem />);
                break;
            case "App-Admin":
                setMainColumnDisplay( <ColumnAppAdmin />)
        }

    }, [main_column_display_type]);

    return (
        <div id="main-container" class="container-fluid">
            <User />
            <div class="row justify-content-center">
                <div id="user-content" class="col-xl-3 d-none d-xl-block">
                    {left_column_display}
                </div>

                <div id="list-content" class="col-sm-11 col-md-5 col-lg-6 col-xl-4">
                    {main_column_display}
                </div>
                
                <div id="detail-content" class="col-md-7 col-lg-6 col-xl-5 d-none d-md-block">
                    {right_column_display}
                </div>
            </div>
        </div>
    );
}